import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import TipwinLogo from "@/components/TipwinLogo";

const NAV_LINKS = [
  { to: "/#angebot", label: "Angebot", testId: "nav-link-angebot" },
  { to: "/#wm-2026", label: "Live-Events", testId: "nav-link-wm2026" },
  { to: "/#faq", label: "FAQ", testId: "nav-link-faq" },
  { to: "/spielerschutz", label: "Spielerschutz", testId: "nav-link-spielerschutz" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const linkClass = ({ isActive }) =>
    `rounded-lg px-3 py-2 text-sm font-medium transition-colors hover:bg-[#1E1E24] hover:text-[#F5F5F3] ${
      isActive ? "text-[#F5F5F3]" : "text-[#A1A1AA]"
    }`;

  return (
    <header className="sticky top-0 z-50 border-b-2 border-[#E11D2A] bg-[#0E0E10]/85 backdrop-blur-xl" data-testid="site-header">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-4 sm:px-6 lg:px-12">
        <div className="flex items-center gap-4">
          <Link to="/" className="flex items-center" data-testid="nav-brand-logo">
            <span className="font-display text-[19px] font-extrabold uppercase leading-none tracking-tight text-[#F5F5F3] sm:text-[22px]">
              Sportwetten<span className="text-[#F54855]">&nbsp;NRW</span>
            </span>
          </Link>
          <span className="hidden h-5 w-px bg-[#27272A] sm:block" aria-hidden="true" />
          <span className="hidden items-center gap-2 sm:ml-12 sm:flex lg:ml-28">
            <span className="text-[10px] uppercase tracking-[0.2em] text-[#A1A1AA]">mit</span>
            <TipwinLogo />
          </span>
        </div>

        <nav className="hidden items-center gap-1 md:flex" aria-label="Hauptnavigation">
          {NAV_LINKS.map((link) =>
            link.to.includes("#") ? (
              <Link key={link.to} to={link.to} className="rounded-lg px-3 py-2 text-sm font-medium text-[#A1A1AA] transition-colors hover:bg-[#1E1E24] hover:text-[#F5F5F3]" data-testid={link.testId}>
                {link.label}
              </Link>
            ) : (
              <NavLink key={link.to} to={link.to} className={linkClass} data-testid={link.testId}>
                {link.label}
              </NavLink>
            ),
          )}
          <Link
            to="/standorte"
            className="ml-2 inline-flex min-h-[44px] items-center rounded-lg bg-[#E11D2A] px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-[#F02837]"
            data-testid="nav-cta-standort-finden"
          >
            Standort finden
          </Link>
        </nav>

        <button
          type="button"
          className="inline-flex min-h-[44px] min-w-[44px] items-center justify-center rounded-lg text-[#F5F5F3] transition-colors hover:bg-[#1E1E24] md:hidden"
          aria-expanded={open}
          aria-controls="mobile-nav"
          aria-label={open ? "Menü schließen" : "Menü öffnen"}
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-mobile-toggle"
        >
          {open ? <X className="h-6 w-6" aria-hidden="true" /> : <Menu className="h-6 w-6" aria-hidden="true" />}
        </button>
      </div>

      {open && (
        <nav id="mobile-nav" className="border-t border-[#27272A] bg-[#0E0E10] px-4 pb-6 pt-3 md:hidden" aria-label="Mobile Navigation" data-testid="nav-mobile-menu">
          <div className="flex flex-col gap-1">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-3 text-base font-medium text-[#F5F5F3] transition-colors hover:bg-[#1E1E24]"
                data-testid={`${link.testId}-mobile`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/standorte"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex min-h-[48px] items-center justify-center rounded-lg bg-[#E11D2A] px-4 py-3 text-base font-semibold text-white transition-colors hover:bg-[#F02837]"
              data-testid="nav-cta-standort-finden-mobile"
            >
              Standort finden
            </Link>
          </div>
        </nav>
      )}
    </header>
  );
}
